import React, { useEffect, useRef, useState } from 'react';

const ClosingStatement = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.4 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="min-h-screen flex flex-col items-center justify-center bg-white text-black py-20 px-6 md:px-12">

      <div className="container mx-auto max-w-5xl text-center">
        <h2
          className="md:text-7xl lg:text-8xl !font-bold !text-7xl mb-16"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(50px)',
            transition: 'opacity 1.2s ease-out, transform 1.2s ease-out'
          }}>AI systems, built for real use - and understood by the people who use them.


        </h2>

        <button
          className="text-lg font-medium px-10 py-5 bg-black text-white rounded-full hover:bg-gray-800 transition-all duration-300 hover:scale-105"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 1s ease-out 0.5s, transform 1s ease-out 0.5s'
          }}>

          Get in touch
        </button>
      </div>

      {/* Footer */}
      <footer
        className="mt-32 pt-12 border-t border-gray-300 w-full max-w-6xl"
        style={{
          opacity: isVisible ? 1 : 0,
          transition: 'opacity 1s ease-out 1s'
        }}>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center text-gray-600 text-sm space-y-6 md:space-y-0">
          <div className="flex flex-col space-y-2">
            <p className="font-medium text-black">Mirai Solutions OÜ</p>
            <p>contact@miraisolutions.com</p>
            <p>Estonia</p>
          </div>
          <div className="flex gap-8">
            <a href="#privacy" className="hover:text-black transition-colors duration-300">Privacy Policy</a>
            <a href="#terms" className="hover:text-black transition-colors duration-300">Terms</a>
            <a href="#contact" className="hover:text-black transition-colors duration-300">Contact</a>
          </div>
        </div>
        <p className="text-gray-500 text-xs mt-8 text-center md:text-left">
          © 2025 Mirai Solutions OÜ. All rights reserved.
        </p>
      </footer>
    </section>);

};

export default ClosingStatement;